{
  "Drill Pipe": {
    "dataLabel": "Drill Pipe",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Grade",
        "dataLabel": "grade"
      },
      {
        "label" : "Range",
        "dataLabel": "range",
        "fixed": 0
      },
      {
        "label" : "Wall",
        "dataLabel": "wall_thickness",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Nominal Weight",
        "dataLabel": "weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "TUBE ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ OD",
        "dataLabel": "tjod",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ ID",
        "dataLabel": "tjid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ Yield",
        "dataLabel": "tool_joint_torsional_strength",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Prem Tube Tensile",
        "dataLabel": "tensile_strength_80",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      }
    ]
  },
  "Landing String": {
    "dataLabel": "Landing String",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Grade",
        "dataLabel": "grade"
      },
      {
        "label" : "Range",
        "dataLabel": "range",
        "fixed": 0
      },
      {
        "label" : "Wall",
        "dataLabel": "wall_thickness",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Nominal Weight",
        "dataLabel": "weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "TUBE ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ OD",
        "dataLabel": "tjod",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ ID",
        "dataLabel": "tjid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ Yield",
        "dataLabel": "tool_joint_torsional_strength",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Prem Tube Tensile",
        "dataLabel": "tensile_strength_80",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      }
    ]
  },
  "HWDP": {
    "dataLabel": "HWDP",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Tube ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "TJ OD",
        "dataLabel": "tjod",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ ID",
        "dataLabel": "tjid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ Yield",
        "dataLabel": "tool_joint_torsional_strength",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Nom Tube Tensile",
        "dataLabel": "tensile_strength_100",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      },
      {
        "label": "Type",
        "dataLabel": "integral"
      },
      {
        "label": "Design",
        "dataLabel": "wear_pad_style"
      }
    ]
  },
  "Drill Collar": {
    "dataLabel": "Drill Collar",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "dcod",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Collar ID",
        "dataLabel": "dcid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label": "Type",
        "dataLabel": "style"
      }
    ]
  },
  "Tubing": {
    "dataLabel": "Tubing",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Grade",
        "dataLabel": "grade"
      },
      {
        "label" : "Weight",
        "dataLabel": "weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Conn OD Box",
        "dataLabel": "connection_od",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Conn OD Pin",
        "dataLabel": "connection_od",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Conn ID",
        "dataLabel": "connection_id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Tube ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Tube Drift",
        "dataLabel": "drift_size",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "New Tube Burst",
        "dataLabel": "burst_capacity_875",
        "imperial": "psi",
        "metric": "MPa",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "New Tube Collapse",
        "dataLabel": "collapse_capacity_100",
        "imperial": "psi",
        "metric": "MPa",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Opt MUT",
        "dataLabel": "opt_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "New Tube Tensile",
        "dataLabel": "tensile_strength_100",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      }
    ]
  },
  "Completion Intervention": {
    "dataLabel": "Completion Intervention",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Grade",
        "dataLabel": "grade"
      },
      {
        "label" : "Range",
        "dataLabel": "range",
        "fixed": 0
      },
      {
        "label" : "Wall",
        "dataLabel": "wall_thickness",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Nominal Weight",
        "dataLabel": "weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Tube ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ OD",
        "dataLabel": "tjod",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ ID",
        "dataLabel": "tjid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ Yield",
        "dataLabel": "tool_joint_torsional_strength",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Prem Tube Tensile",
        "dataLabel": "tensile_strength_80",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      }
    ]
  },
  "Worktech": {
    "dataLabel": "Worktech",
    "columns": [
      {
        "label" : "PDF"
      },
      {
        "label" : "OD",
        "dataLabel": "od",
        "imperial": "in",
        "metric": "mm",
        "fractional": true
      },
      {
        "label" : "Connection",
        "dataLabel": "connection_type"
      },
      {
        "label" : "Grade",
        "dataLabel": "grade"
      },
      {
        "label" : "Range",
        "dataLabel": "range",
        "fixed": 0
      },
      {
        "label" : "Wall",
        "dataLabel": "wall_thickness",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "Nominal Weight",
        "dataLabel": "weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Adjusted Weight",
        "dataLabel": "adjusted_weight",
        "imperial": "lbs/ft",
        "metric": "kg/m",
        "fixed": 2
      },
      {
        "label" : "Tube ID",
        "dataLabel": "id",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ OD",
        "dataLabel": "tjod",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ ID",
        "dataLabel": "tjid",
        "imperial": "in",
        "metric": "mm"
      },
      {
        "label" : "TJ Yield",
        "dataLabel": "tool_joint_torsional_strength",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": 0,
        "commas": true
      },
      {
        "label" : "Min MUT",
        "dataLabel": "min_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Max MUT",
        "dataLabel": "max_mut",
        "imperial": "ft-lbs",
        "metric": "N-m",
        "fixed": -2,
        "commas": true
      },
      {
        "label" : "Prem Tube Tensile",
        "dataLabel": "tensile_strength_80",
        "imperial": "lbs",
        "metric": "kN",
        "fixed": 0,
        "commas": true
      }
    ]
  }
}